export function toIso8601DateString(date: Date | null): string | null {
    if (date === null || Number.isNaN(date.getTime())) {
        return null;
    }
    return date.toISOString();
}
